import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { GetDemoComponent } from '@pyg-shared/get-demo/get-demo.component';

@Component({
  selector: 'app-try-demo',
  templateUrl: './try-demo.component.html',
  styleUrls: ['./try-demo.component.scss'],
  imports: [TranslatePipe, GetDemoComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TryDemoComponent {}
